import React from 'react';
import { Category } from '@v2/shared/lib/types';
import TwoStripNavigation from '@v2/shared/Layouts/Full/TwoStripNavigation';

import logo from './images/logo.png';

type Props = {
  categories?: Category[];
};

/**
 * Ported from `domain-overrides/magspot.com/layouts/full/header.html`.
 *
 * The arrangement is TwoStripNavigation, which MagZoom draws too — the two legacy
 * headers were the same markup with a different mark and MagZoom's extra links. What
 * MagSpot says for itself is the logo, and that it has no such links: passing none is
 * what puts its account links in the header from sm rather than md.
 */
export default function Navigation({ categories }: Props) {
  return (
    <TwoStripNavigation
      categories={categories}
      searchId="magspot-search"
      logo={{ src: logo, width: 139, height: 33, className: 'w-[139px] h-[33px] block' }}
    />
  );
}
